import styled from "styled-components";
import Color from "../../../../assets/styles/colors";

export const Div = styled.div`
  ${(props) =>
    props.theme.isDarkTheme &&
    `color: ${
      props.theme.isDarkTheme
        ? Color.textColorBlackSeven
        : Color.textColorBlackFor
    };`}
`;

export const ButtonBox = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  fontsize: 12px;
  z-index: 1000;
`;

export const Marker = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  text-align: center;
  z-index: 11000;
`;

export const MarkerImg = styled.img``;
